export default __webpack_public_path__ + "static/media/icon-redirect-1.1574d258.svg";